var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['ya-share2', _vm.className],attrs:{"data-services":_vm.socialServices,"data-title":_vm.social['title'],"data-description":_vm.social['text']}})}
var staticRenderFns = []

export { render, staticRenderFns }